import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import UneditableInput from "../../components/UneditableInput";
import AdditionalInformation from "../../components/AdditionalInformation";
import JsonTable from '../../components/JsonTable';
import CardMetrics from '../../components/CardMetrics';

import { getAsyncTasks } from "../../services/asynctask";
import { getIssues } from "../../services/issue";
import { getChannels } from "../../services/channel";

import { showAlert } from "../../store/ducks/alert";

import { CircularProgress } from "@material-ui/core";


const AsyncTasksInformation = (props) => {
  const dispatch = useDispatch();
  const [task, setTask] = useState({});
  const [taskIssue, setTaskIssue] = useState(null);
  const [taskChannel, setTaskChannel] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayTask();
  }, []);

  const displayTask = async () => {
    const taskId = props.match.params.id;

    try {
      setIsLoading(true);

      const { data } = await getAsyncTasks(0, {searchItem: "id", search: taskId});
      try {
        let issue = data.rows[0].payload.issueId;
        if(issue) {
          issue = await getIssues(0, {searchItem: "id", search: data.rows[0].payload.issueId});
          setTaskIssue(issue.data.rows);
        }
        let channel = data.rows[0].payload.channel.id;
        if(channel) {
          channel = await getChannels( 0, { searchItem: "id",search: data.rows[0].payload.channel.id} );
          setTaskChannel(channel.data.rows);
        }
      } catch (error) {}

      setTask(data.rows[0]);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert("error", "Ops! We could not load. 😔"));
      console.log(error);
    }
  };

  const uneditable = Object.keys(task).filter((key) => key !== "payload");


  if (isLoading)
    return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>Async Task Information</h1>
      </div>
      <section className="update-section">
        <h3>View Async Task Properties</h3>
        <form className="update-form">
          <div className="form-fields">
            <UneditableInput data={task} labels={uneditable} />
          </div>
        </form>
      </section>
      <section className="additional-section">

      {task.taskType == 'BULK_EMAIL_REGISTER' && task.payload && task.payload.total && task.payload.log && (
        <>
          <h3>Result</h3>
          <CardMetrics data={
            {total: task.payload.total, failed: task.payload.total - (task.payload.log.filter(x => isNaN(x)).length)}
          } />
        </>
      )}

    { task.taskType == 'BULK_EMAIL_REGISTER' && task.payload && task.payload.total && !task.payload.log && (
        <>
          <h3>Wainting Confirmation Of:</h3>
          <CardMetrics data={
            {total: task.payload.total}
          } />
        </>
    )}

      { taskChannel && (
          <div>
            <h3>Channel</h3>
            <AdditionalInformation
              data={taskChannel}
              dataKey="name"
              path="channels"
              useUid={true}
            />
          </div>
        )
      }

      { taskIssue ? (
          <div>
            <h3>Issue</h3>
            <AdditionalInformation
              data={taskIssue}
              dataKey="subject"
              path="issues"
            />
          </div>
        ) : ''
      }

      { task.payload && (
          <div>
            <h3>Payload</h3>
            <JsonTable data={task.payload} />
          </div>
        )
      }


      </section>

    </>
  );
};

export default AsyncTasksInformation;
